import React from 'react'

function StudyTips() {
    return (
        <div>StudyTips</div>
    )
}

export default StudyTips